[  
  {
    "anchorType": "group",
    "anchorTypeLabel": "קבוצה",
    "regex": "^(https?:\\/\\/)?t\\.me\\/.+"
  },
  {
    "anchorType": "number",
    "anchorTypeLabel": "טלפון",
    "regex": "^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$"
  }
]
